import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import styles from '../FooterSimplified.module.scss';

const FooterSimplifiedStoreIcon = props => (
  <LazyLoad offset={100} once>
    <img className={styles['footer__store-icon']} {...props} />
  </LazyLoad>
);

FooterSimplifiedStoreIcon.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

export default FooterSimplifiedStoreIcon;
